import { motion } from 'framer-motion';

const Skeleton = ({ className }) => {
  return (
    <motion.div
      className={`bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse ${className}`}
      initial={{ opacity: 0.6 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.6 }}
      transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
    />
  );
};

export default Skeleton; 